<template>
  <div id="gptPage">
    <a-row>
      <a-col :span="6"></a-col>
      <a-col :span="12">
        <div class="gpt-container">
          <div class="gpt-top">
            <text class="gpt-title">BodorGPT</text>
          </div>
          <div class="gpt-middle cu-chat" ref="chatContainer">
            <div
              class="cu-item m-item"
              :class="content.selfShow"
              v-for="(content, index) in contents"
              :key="index"
            >
              <a-avatar
                v-if="content.touLeft"
                :src="content.head"
                shape="square"
                size="large"
              />
              <!-- <image
                
                class="cu-avatar radius"
                
                style="border-radius: 5px"
              ></image> -->
              <div class="main">
                <div
                  class="content shadow"
                  v-if="content.textShow"
                  :class="content.bgGreen"
                >
                  <!--文本-->
                  <div
                    class="loading-dots"
                    v-if="content.reasoningText == '' && content.touLeft && !answerShow"
                  >
                    <div class="dot">.</div>
                    <div class="dot">.</div>
                    <div class="dot">.</div>
                  </div>
                  <div style="width: 100%; white-space: break-spaces">
                    <!-- color: #b5b6b9; -->
                    <div
                      v-if="content.touLeft && content.reasoningText != ''"
                      style="
                        color: #b5b6b9;
                        border-left: 3px solid #b5b6b9;
                        padding-left: 10px;
                      "
                    >
                      深度思考中...... <br />
                      {{ content.reasoningText }}
                    </div>
                    <text>{{ content.text }}</text>
                  </div>
                  <!-- <text style="width: 100%; white-space: pre-wrap">{{
                    content.text
                  }}</text> -->
                </div>
              </div>
              <a-avatar
                v-if="content.touRight"
                :src="content.head"
                shape="square"
                size="large"
              />
              <!-- <image
                :src="content.head"
                class="cu-avatar radius"
                v-if="content.touRight"
                style="border-radius: 5px"
              ></image> -->
              <div class="date">{{ content.time }}</div>
            </div>
          </div>
          <div class="gpt-bottom">
            <!-- <textarea
              class="gpt-input"
              v-model="inputText"
              placeholder="请输入您要问的问题"
            ></textarea> -->
            <a-textarea
              v-model:value="inputText"
              :bordered="false"
              placeholder="请输入您要问的问题"
              :auto-size="{ minRows: 4, maxRows: 4 }"
            />
            <div>
              <button class="gpt-button" v-if="answerShow" @click="send">发送</button>

              <button
                class="cu-btn answerIng shadow"
                v-else-if="contents[contents.length - 1].reasoningText == ''"
              >
                思考中,请等待...
              </button>
              <button class="cu-btn gpt-button shadow" v-else @click="cancelAnwser">
                停止回答
              </button>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6"></a-col>
    </a-row>
  </div>

  <!-- <div id="gptPage">
    <div class="gpt-container">{{ contentStr }}</div>
    <button @click="goClick">点击</button>
  </div> -->
</template>
<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import axios from "axios";
import { ref, onMounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import useImg from "@/assets/img/header.png";
import sidImg from "@/assets/img/head.jpg";

const chatContainer = ref(null); //聊天容器
let userScrolledUp = ref(false); //用户是否已滚动到底部
let cancelReply = ref(false); //是否取消回复

const answerShow = ref(true); //回答按钮显示状态
const router = useRouter();
const inputText = ref(""); //输入内容
const inputTextNew = ref(""); //最新输入内容
const urlCommon = ref("/api/v1/chat/completions");
const token = ref(
  "Bearer fastgpt-zzj8V1B6KmAVb0GoKqCAMq9Wkq1aYxf06c5mFVETVD1g5w0yDUtYysiSoFOGZalFi"
);
const contentStr = ref("gpts");
const contents = ref([]);
let user = JSON.parse(localStorage.getItem("user"));

// const abortController = ref(null);

//滚动到底部
const scrollToBottom = () => {
  if (chatContainer.value) {
    chatContainer.value.scrollTop = chatContainer.value.scrollHeight;
  }
};

//监听滚动事件
const handleScroll = () => {
  if (chatContainer.value) {
    userScrolledUp.value =
      chatContainer.value.scrollTop + chatContainer.value.clientHeight <
      chatContainer.value.scrollHeight - 50;
  }
};

//监听消息变化
watch(
  contents,
  () => {
    nextTick(() => {
      if (!userScrolledUp.value) {
        scrollToBottom();
      }
    });
  },
  { deep: true }
);

//点击发送
function send() {
  console.log("点击发送：", inputText.value);
  if (inputText.value.trim() === "") {
    message.warning("请输入内容");
  } else {
    inputTextNew.value = inputText.value;
    let onlObj = {
      text: inputText.value,
      selfShow: "self",
      bgGreen: "bg-green",
      touLeft: false, //对方头像
      touRight: true, //自己头像
      textShow: true, //文本聊天
      head: useImg,
      time: formatWeChatTime(),
    };
    if (user.url != "") {
      console.log("头像：", user);
      onlObj.head = "https://apicloud.bodor.com" + user.Url;
      console.log("头像1：", onlObj.head);
    } else {
      console.log("头像2：", user);
      onlObj.head = useImg;
    }
    contents.value.push(onlObj);

    nextTick(() => {
      if (!userScrolledUp.value) {
        scrollToBottom();
      }
    });
    //获取内容
    goClick(inputText.value, contents.value.length);
  }
}

function formatWeChatTime(date = new Date()) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const diffDays = Math.floor((today - targetDate) / (1000 * 60 * 60 * 24));

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const timeStr = `${hours}:${minutes}`;

  if (diffDays === 0) {
    return timeStr;
  } else if (diffDays === 1) {
    return `昨天 ${timeStr}`;
  } else if (diffDays < 7) {
    const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return `${weekdays[date.getDay()]} ${timeStr}`;
  } else {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${day} ${timeStr}`;
  }
}

const abortController = ref(null);
//取消发送
function cancelAnwser() {
  answerShow.value = true;
  if (abortController.value) {
    abortController.value.abort(); //取消请求
    abortController.value = null;
  }
}

/******************方案二，可取消回答，单********************* */
async function goClick(e, id) {
  abortController.value = new AbortController();
  try {
    answerShow.value = false;
    let fullResponse = "";
    let reasoningFullResponse = "";
    inputText.value = "";

    let onlObj = {
      text: fullResponse,
      reasoningText: reasoningFullResponse,
      selfShow: "selfHide",
      bgGreen: "bg-gray",
      touLeft: true,
      touRight: false,
      textShow: true,
      head: sidImg,
      time: formatWeChatTime(),
    };
    contents.value.push(onlObj);

    let params = {
      stream: true,
      detail: false,
      messages: [{ role: "user", content: e }],
    };

    const response = await axios({
      url: "/v1/chat/completions",
      method: "post",
      headers: {
        Authorization: token.value,
        // "Content-Type": "application/json",
        "Context-type": "text/event-stream",
      },
      data: params,
      responseType: "text", // 在浏览器中使用text
      signal: abortController.value.signal,
      onDownloadProgress: (progressEvent) => {
        // 处理流式数据
        const chunk = progressEvent.event.target.responseText;
        processStreamChunk(chunk, fullResponse, reasoningFullResponse);
      },
    });
    answerShow.value = true;
  } catch (err) {
    if (axios.isCancel(err)) {
      console.log("请求已被用户取消");
    } else {
      console.error("goClick error:", err);
    }
    answerShow.value = true;
  }
}

// 处理流式数据块的函数
function processStreamChunk(rawChunk, fullResponse, reasoningFullResponse) {
  try {
    // 假设数据是SSE格式，按\n\n分割事件
    const events = rawChunk.split("\n");
    console.log("events:", events);
    events.forEach((event, index) => {
      // setTimeout(() => {
      if (!event.trim()) return;

      if (event.startsWith("data: ")) {
        const jsonStr = event.substring(6).trim();
        if (jsonStr === "[DONE]") {
          answerShow.value = true;
          return;
        }

        try {
          const data = JSON.parse(jsonStr);
          // console.log("data:" + index, data.choices[0]?.delta);
          const reasoningContent = data.choices[0]?.delta?.reasoning_content || "";
          const content = data.choices[0]?.delta?.content || "";

          reasoningFullResponse += reasoningContent;
          fullResponse += content;

          // 更新最后一条消息的内容
          contents.value[contents.value.length - 1].reasoningText = reasoningFullResponse;
          contents.value[contents.value.length - 1].text = fullResponse;
        } catch (e) {
          console.error("JSON parse error:", e, "on event:", event);
        }
      }
      // }, 1);
    });
  } catch (error) {
    console.error("处理数据块出错:", error);
  }
}

/*************方案一原请求方式************ */
// async function goClick(e, id) {
//   // 创建新的AbortController
//   // abortController.value = new AbortController();
//   try {
//     answerShow.value = false; //发送按钮因此
//     // cancelReply.value = false; //取消回复
//     let buffer = "";
//     let fullResponse = "";
//     let reasoningFullResponse = ""; //思考
//     inputText.value = ""; //清空输入框
//     let onlObj = {
//       text: fullResponse,
//       reasoningText: reasoningFullResponse, //思考
//       selfShow: "selfHide",
//       bgGreen: "bg-gray",
//       touLeft: true, //对方头像
//       touRight: false, //自己头像
//       textShow: true, //文本聊天
//       head: sidImg,
//       time: formatWeChatTime(),
//     };
//     contents.value.push(onlObj);
//     let params = {
//       stream: true,
//       detail: false,
//       messages: [
//         {
//           role: "user",
//           content: e,
//         },
//       ],
//     };
//     console.log("params:", params);
//     const response = await axios({
//       url: "/v1/chat/completions",
//       timeout: 60000,
//       method: "post",
//       headers: {
//         Authorization: token.value,
//         // 'Content-Type': 'application/json',
//         "Context-type": "text/event-stream",
//       },
//       data: params,
//       responseType: "text",
//       // signal: abortController.value.signal, //传入signal
//     });
//     console.log("response:", id, response.data);
//     const chunk = response.data;
//     buffer += chunk;
//     //处理可能的多条消息
//     const lines = buffer.split("\n");
//     buffer = lines.pop(); //保存未完成的行
//     // for(const line of lines){
//     lines.forEach((line, index) => {
//       // let _this = this;
//       setTimeout(() => {
//         if (line.startsWith("data: ")) {
//           const jsonStr = line.substring(6); //去掉“data:"前缀
//           if (jsonStr.trim() === "[DONE]") {
//             console.log("Stream completed");
//             answerShow.value = true;
//             return;
//             // continue;
//           }
//           try {
//             if (answerShow.value) {
//               // answerShow.value = true; //发送按钮显示
//               return;
//             }
//             const data = JSON.parse(jsonStr);
//             // if (data.choices[0]?.delta?.content.includes(inputTextNew.value)) {
//             //提取思考内容
//             const reasoningContent = data.choices[0]?.delta?.reasoning_content || "";
//             reasoningFullResponse += reasoningContent;
//             //提取实际内容
//             const content = data.choices[0]?.delta?.content || "";
//             fullResponse += content;
//             console.log("app内容：", contents.value.length - 1, fullResponse);
//             // contentStr.value = fullResponse;
//             //思考内容
//             contents.value[
//               contents.value.length - 1
//             ].reasoningText = reasoningFullResponse;
//             //实际内容
//             contents.value[contents.value.length - 1].text = fullResponse;
//             // }
//           } catch (e) {
//             answerShow.value = true;
//             // _this.answerShow = true;
//             console.error("JSON parse error:", e, "on line:", line);
//           }
//         }
//       }, index * 10);
//     });

//     // Node.js 环境下的流处理（浏览器环境需额外适配）
//     response.data.on("data", (chunk) => {
//       console.log("chunk:", chunk.toString());
//       // streamData.value += chunk.toString();
//     });
//   } catch (err) {
//     // message.error("请求失败,请检查网络");
//     console.log("发送失败");
//     console.error("goClick error:", err);
//   }
// }
</script>

<style scoped>
#gptPage {
  width: 100%;
  height: 100%;
  margin-top: 60px;
  background: #f7f9fa;
}
.gpt-container {
  width: 100%;
  height: 85vh;
  background: #fff;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin-top: 1vh;
  border-radius: 10px;
}
.gpt-top {
  height: 50px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 50px;
  padding-left: 20px;
  font-size: 20px;
}
.gpt-bottom {
  height: 150px;
  border-top: 1px solid #e8e8e8;
}
.gpt-middle {
  height: calc(100% - 200px);
  overflow-y: auto;
}
.gpt-middle::-webkit-scrollbar {
  width: 0;
}

.gpt-input {
  width: 100%;
  height: 70%;
  padding: 10px;
  border: none;
  resize: none;
}
.gpt-input:focus {
  border: none;
}
/* ==================
         聊天
 ==================== */

.cu-chat .self {
  display: flex;
  padding: 30px 30px 30px 200px;
  position: relative;
}
.cu-chat .selfHide {
  display: flex;
  padding: 30px 200px 30px 30px;
  position: relative;
}

.cu-chat .cu-item > .cu-avatar {
  width: 160px;
  height: 160px;
}

.cu-chat .cu-item > .main {
  max-width: calc(100% - 50px);
  margin: 0;
  display: flex;
  align-items: center;
}

.cu-chat .cu-item > image {
  height: 320upx;
}

.cu-chat .cu-item > .main .content {
  padding: 10px;
  border-radius: 6px;
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  font-size: 16px;
  position: relative;
  /* min-height: 80upx; */
  line-height: 20px;
  min-height: 50%;
  text-align: left;
  word-wrap: break-word;
  margin: 0 10px;
}

.cu-chat .cu-item > .main .content:not([class*="bg-"]) {
  background-color: #ffffff;
  color: #333333;
}

/* .cu-chat .cu-item .date {
  position: absolute;
  font-size: 12px;
  color: #8799a3;
  width: calc(100% - 320px);
  bottom: 00px;
  left: 160px;
} */
.cu-chat .self .date {
  position: absolute;
  font-size: 12px;
  color: #8799a3;
  width: calc(100% - 320px);
  bottom: 00px;
  right: 80px;
}
.cu-chat .selfHide .date {
  position: absolute;
  font-size: 12px;
  color: #8799a3;
  width: calc(100% - 320px);
  bottom: 00px;
  left: 80px;
}

.cu-chat .cu-item .action {
  padding: 0 30upx;
  display: flex;
  align-items: center;
}

.cu-chat .cu-item > .main .content::after {
  content: "";
  top: 27upx;
  transform: rotate(45deg);
  position: absolute;
  z-index: 100;
  display: inline-block;
  overflow: hidden;
  width: 24upx;
  height: 24upx;
  left: -12upx;
  right: initial;
  background-color: inherit;
}

.cu-chat .cu-item.self > .main .content::after {
  left: auto;
  right: -12upx;
}

.cu-chat .cu-item > .main .content::before {
  content: "";
  top: 30upx;
  transform: rotate(45deg);
  position: absolute;
  z-index: -1;
  display: inline-block;
  overflow: hidden;
  width: 24upx;
  height: 24upx;
  left: -12upx;
  right: initial;
  background-color: inherit;
  filter: blur(5upx);
  opacity: 0.3;
}

.cu-chat .cu-item > .main .content:not([class*="bg-"])::before {
  background-color: #333333;
  opacity: 0.1;
}

.cu-chat .cu-item.self > .main .content::before {
  left: auto;
  right: -12upx;
}

.cu-chat .cu-item.self {
  justify-content: flex-end;
  text-align: right;
}

.cu-chat .cu-info {
  display: inline-block;
  margin: 20upx auto;
  font-size: 24upx;
  padding: 8upx 12upx;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 6upx;
  color: #ffffff;
  max-width: 400upx;
  line-height: 1.4;
}
.bg-green {
  background-color: #39b54a;
  color: #ffffff;
}
.bg-gray {
  background-color: rgba(29, 29, 31, 0.7);
  /* background-color: #daeafc; */
  color: #ffffff;
}
.cu-bar.foot {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1024;
  box-shadow: 0 -1upx 6upx rgba(0, 0, 0, 0.1);
}
.cu-bar.input {
  padding-right: 20upx;
  background-color: #eeeeee;
}

.cu-bar.input input {
  overflow: initial;
  line-height: 64upx;
  height: 64upx;
  min-height: 64upx;
  flex: 1;
  font-size: 30upx;
  margin: 0 20upx;
  background: #fff;
  border-radius: 5px;
  padding: 0 5px;
}

.cu-bar.input .action {
  margin-left: 20upx;
}

.cu-bar.input .action [class*="cuIcon-"] {
  font-size: 48upx;
}

.cu-bar.input input + .action {
  margin-right: 20upx;
  margin-left: 0upx;
}

.cu-bar.input .action:first-child [class*="cuIcon-"] {
  margin-left: 0upx;
}
.cu-bar {
  display: flex;
  position: relative;
  align-items: center;
  min-height: 100upx;
  justify-content: space-between;
  background-color: #eeeeee;
}

.iconBottom {
  font-size: 22px !important;
}
#sendBtn {
  line-height: 31px;
  font-size: 16px;
  margin-right: 5px;
}
#onlBack {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #212121;
}
/********************************************
					界面
********************************************/
.videoBox {
  position: relative;
  border-radius: 3px;
  overflow: hidden;
}
.videoIcon {
  font-size: 30px;
  position: absolute;
  left: calc(50% - 15px);
  top: calc(50% - 15px);
}
.vidCloseIcon {
  color: #fff !important;
  font-size: 20px;
}
#vidBox {
  position: relative;
  background: #000;
}
#vidClose {
  position: absolute;
  left: 20px;
  top: 40px;
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.3);
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  z-index: 100000;
}
.txtFile {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/* 思考中 */
.loading-dots {
  display: flex;
  align-items: center;
  height: 24px;
  padding: 0;
}

.dot {
  margin: 0 0px 33px 0;
  font-size: 54px;
  opacity: 0;
  animation: dot-breath 1.5s infinite ease-in-out;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}
.dot:nth-child(2) {
  animation-delay: 0.5s;
}
.dot:nth-child(3) {
  animation-delay: 1s;
}

@keyframes dot-breath {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
.answerIng {
  float: right;
  color: #fff;
  background: #aaa;
  border: none;
  padding: 5px 20px;
  border-radius: 5px;
  margin-right: 20px;
  font-size: 16px;
}
.gpt-button {
  float: right;
  color: #fff;
  background: #4598f0;
  border: none;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 16px;
  margin-right: 20px;
}
</style>
